export default __webpack_public_path__ + "static/media/outsystems-logo-ring-main.12c3c40f.png";